function questionModel(question) {
  return {
    uid: question.uid,
    id: question.id,
    doubtUID: question.doubt_uid,
    solutionUID: question.solution_uid,
    title: question.title,
    page: question.page,
    solutionDuration: question.solution_duration,
    solutionVideoUrl: question.solution_video_url,
    doubtImageUrl: question.doubt_image_url,
    xType: question.type,
    marks: question.marks,
    type: 'book', // book || papers
    secText1: question.sub_titles?.[0]?.text,
    secText2: question.sub_titles?.[1]?.text,
    ctlgIcon: question.icon
  };
}

function getEntityData(data) {
  return questionModel(data);
}

const question = { Question: questionModel, getEntityData };

export default question;
